// React
import React from "react";
import { Link } from "react-router-dom";

// DateTime
const { DateTime } = require("luxon");

export default function PersonIndexItem({ person = {}, ...props }) {

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone("America/Los_Angeles");
    const timeString = timeObject.toLocaleString(DateTime.DATE_MED);
    return (
        <p>{timeString}</p>
    )
  }

  return (
    <Link
      to={`/person/${person.personid}`}
      className="event-index-item"
    >
      <div>
        <h3>{person.name}</h3>
        <p>{person.email}</p>
      </div>
      <div>
        <p>Updated:</p>
        <>
          {formatTime(person.updated)}
        </>
      </div>
    </Link>
  );
}
